<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-md(:title="$t('mantra')")
  
  Query(
    :query="require('~/graphql/Highlight.gql').Highlights"
    :limit="10"
    :initialValue="highlights"
    :variables="{ type: 'MOMENT' }"
    v-slot="{ items }"
  )
    AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
      MomentCard(
        :slug="item.slug"
        :img="item.media.src"
        :ratio="ratio"
        :title="item.caption"
        :autoRatio="true"
        :likes="item.likes"
        @zoomin="onSelect(item)"
      )

  TheaterOverlay(
    :isActive="!!selectedItem.id"
    :title="selectedItem.caption"
    :image="selectedItem.media.src"
    @close="onLeave"
  )
    template(#buttons)
      .momentCard-overlay-like(@click="like")
        AppIcon(name="like")
        span {{ selectedItem.likes }}

</template>

<script>
import { Highlights, Highlight, LikeHighlight } from '~/graphql/Highlight.gql';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import Query from '~/components/Query';
import MomentCard from '~/components/MomentCard';
import TheaterOverlay from '~/components/TheaterOverlay';

export default {
  key: 'moments',
  preserveScrollPosition: true,
  components: {
    AsymetricGrid,
    Query,
    MomentCard,
    TheaterOverlay
  },
  meta: {
    logoText: 'moments'
  },
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/moments.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/moments.png'
        }
      ]
    };
  },
  async asyncData({ app, params, from }) {
    if (from && from.name.indexOf('culture-moments-slug') === 0) {
      return {};
    }

    const [moments, moment] = await Promise.all([
      app.$api.query({
        query: Highlights,
        variables: {
          type: 'MOMENT',
          first: 10
        }
      }),
      params.slug
        ? app.$api.query({
            query: Highlight,
            variables: {
              slug: params.slug
            }
          })
        : undefined
    ]);

    const payload = {
      highlights: moments.data.highlights,
      selectedItem: {
        likes: 0,
        id: null,
        caption: '',
        media: { src: '' }
      }
    };

    if (params.slug && moment) {
      payload.highlights.edges.push({ node: moment.data.highlight });
      payload.selectedItem = moment.data.highlight;
    }

    return payload;
  },
  methods: {
    onLeave() {
      this.selectedItem = {
        likes: 0,
        id: null,
        caption: '',
        media: { src: '' }
      };
      this.$router.localePush('/moments');
    },
    async like() {
      try {
        this.selectedItem.likes++;
        const { data } = await this.$api.mutate({
          mutation: LikeHighlight,
          variables: {
            id: this.selectedItem.id
          }
        });

        return data;
      } catch (err) {
        console.error(err);
      }
    },
    onSelect(item) {
      this.selectedItem = item;
      this.$router.localePush(`/moments/${item.slug}`);
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Moments",
    "pageDesc":"See the Baianaters moments and fun stories in everyday life. Have a sneak peek inside our office culture and environment",
    "mantra":"Memories, moments |and fun times."
  },
  "ar": {
    "pageTitle":"لحظات بيانات",
    "pageDesc":"شاهد لحظات Baianaters وقصصنا الممتعة وحياتنا اليومية لحظة بلحظة. احصل على نظرة خاطفة حول ثقافتنا وما نقوم به داخل مقرنا.",
    "mantra":"ذكرياتنا و أوقاتنا |الممتعة."
  }
}
</i18n>
